/* eslint-disable lines-between-class-members */

interface PlanItemInterface {
  planKey: string,
  label: string,
  group: number,
  usedKey?: string,
  formatter?: CallableFunction,
}

class PlanItem {
  public planKey: string;
  public usedKey: string;
  public label: string;
  public group: number;
  public formatter: CallableFunction;
  public used?: string | number | boolean;
  public contracted: string | number | boolean = '-';
  public modified: boolean = false;

  constructor(obj: PlanItemInterface) {
    this.planKey = obj.planKey;
    this.label = obj.label;
    this.group = obj.group;
    this.usedKey = obj.usedKey ?? this.planKey;
    this.formatter = obj.formatter ?? ((value: string | number | boolean) => value);
  }

  public formatInfo(value: string | number | boolean): string {
    const val = this.formatter(value);
    switch (typeof val) {
      case 'boolean':
        return val ? '\u2713' : '\u2715';
      case 'number':
        return `${+val.toFixed(2)}`;
      default:
        return val;
    }
  }

  public getFullInfo = (): string => (this.used ? (
    `${this.formatInfo(this.used)} / ${this.formatInfo(this.contracted)}`
  ) : this.formatInfo(this.contracted));

  public setUsed = (...data: Record<string, number | boolean | string>[]): void => {
    for (let i = 0; i < data.length; i += 1) {
      const item = data[i];
      if (item?.[this.usedKey] !== undefined) {
        this.used = item[this.usedKey];
        break;
      }
    }
  };

  public setContracted = (
    fromCompany: Record<string, number | boolean | string>,
    fromPlan: Record<string, number | boolean | string>,
  ): void => {
    this.contracted = fromCompany?.[this.planKey] ?? fromPlan?.[this.planKey];
    this.modified = this.contracted !== fromPlan?.[this.planKey];
  };
}

export default PlanItem;
